// @flow
import React from 'react';
import styled, {css} from 'styled-components';
import {Icon, IconLookup} from 'trustar-2.0/components';

const StyledCheckmarkButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: .05rem;
  border-radius: 0;
  border: 1px solid #CCCCCC;
  width: 1rem;
  height: 1rem;
  i {
    font-size: .8rem;
    font-weight: bold;
  }

  ${props => props.size && css`
    width: ${props.size};
    height: ${props.size};
  `}
`;

export const CheckmarkButton = (props: Object) => {
  return (
    <StyledCheckmarkButton size={props.size}>
      { props.isChecked && <Icon icon={IconLookup.CHECK} /> }
    </StyledCheckmarkButton>
  );
};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Button/CheckmarkButton.js